module.exports = __webpack_public_path__ + "static/beats-email-c98502b4479c31946df9988ba4d8185a.jpg";